export default __webpack_public_path__ + "static/media/promptpedia.4d43c062.png";